export default "__VITE_ASSET__DLJv72x8__"